module.exports = __webpack_public_path__ + "static/media/offres_auto_3.0277e372.png";